export default class EncryptService {
  public static getBase64String(value: string): string {
    return atob(value);
  }
}
